import { render, staticRenderFns } from "./applyTalent.vue?vue&type=template&id=67caf962&scoped=true&"
import script from "./applyTalent.vue?vue&type=script&lang=js&"
export * from "./applyTalent.vue?vue&type=script&lang=js&"
import style0 from "./applyTalent.vue?vue&type=style&index=0&id=67caf962&prod&lang=less&scoped=true&"
import style1 from "./applyTalent.vue?vue&type=style&index=1&id=67caf962&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67caf962",
  null
  
)

export default component.exports